var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0326 0.203125H8.18354C7.86277 0.203125 7.41443 0.388961 7.18778 0.615436L0.539675 7.26351C0.0857333 7.71694 0.0857333 8.46035 0.539675 8.91323L5.48973 13.8631C5.94265 14.3165 6.68534 14.3165 7.13894 13.8626L13.787 7.21556C14.0135 6.98911 14.1994 6.54006 14.1994 6.21997V1.36985C14.1994 0.728298 13.6742 0.203125 13.0326 0.203125ZM10.6991 4.86986C10.0548 4.86986 9.53242 4.34695 9.53242 3.70314C9.53242 3.05827 10.0548 2.53641 10.6991 2.53641C11.3435 2.53641 11.866 3.05827 11.866 3.70314C11.8661 4.34695 11.3435 4.86986 10.6991 4.86986Z",
    fill: "#757575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.9ab2d5b220d6053978e86f980d210829.svg";
export { ForwardRef as ReactComponent };